module.exports = __webpack_public_path__ + "media/barometer/disclosure-5a8ec2cc.png";